import Vue from 'vue';
import Storage from 'vue-ls';
import VueAMap from 'vue-amap';
import { Component } from 'vue-property-decorator';
import App from './App.vue';
import router from './router';
// 组件按需加载
import '@/element';

// 导入图标组件
import 'src/icons/index';

// 标准化浏览器样式
import 'normalize.css/normalize.css';
// 定制主题
import 'theme/theme.scss';

import store from './store';


Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

const options = {
  namespace: 'service-Pro__',
  name: 'ls',
  storage: 'local',
};

// 启用vue-ls本地存储
Vue.use(Storage, options);
// 是否开启vue在生产环境的提示功能
Vue.config.productionTip = false;
// 高德地图插件
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '2f46374f8390adc7c6d324084c826de3',
  v: '1.4.4',
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
